/** Swell rswETH — `getRate()` returns ETH-per-share at 1e18.
 *  Same shape as EtherFi's `getRate()` but kept as its own fragment so
 *  this file is self-contained. */
export const SwellGetRateAbi = [
  {
    name: 'getRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
